import {
  Document,
  Text,
  Page,
  StyleSheet,
  Image,
  View,
} from "@react-pdf/renderer";
import frameAso from "./images/frame_asociart.png";
import { formatearFechaLuxon } from "../../../../../modules/utils/formatearFecha";
import { WEBURLEGALES } from "../../../../helpers/frontend.js"

const styles = StyleSheet.create({
  page: {
    paddingTop: 10,
    paddingRight: 10,
    paddingLeft: 10,
    paddingBottom: 40,
  },
  title: {
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: "right",
    color: "black",
    backgroundImage: `url("${WEBURLEGALES}/images/frame_asociart.png")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    marginTop: 20,
    marginRight: 20,
    height: 50,
  },
  section: {
    display: "flex",
    flexDirection: "row",
  },
  parragraph10: {
    fontSize: 10,
    textAlign: "left",
  },
  parragraphSub10: {
    fontSize: 10,
    textAlign: "right",
  },
  parragraph: {
    fontSize: 12,
    textAlign: "left",
    lineHeight: 1.5,
    margin: 10,
  },
  tableHeader: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: 10,
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  row: {
    display: "flex",
    flexDirection: "row",
  },
  header: {
    fontWeight: "bold",
  },
  cell: {
    flex: 1,
    padding: 8,
    fontSize: 12,
    borderLeft: "1px solid gray",
    borderRight: "1px solid gray",
  },
  cell1: {
    flex: 1,
    padding: 8,
    fontWeight: "900",
    fontSize: 12,
    backgroundColor: "#E4E4E4",
    border: "1px solid gray",
  },
  cell2: {
    flex: 1,
    padding: 8,
    fontSize: 12,
    borderLeft: "1px solid gray",
    borderRight: "1px solid gray",
  },
  cell3: {
    flex: 1,
    padding: 8,
    fontSize: 12,
    borderLeft: "1px solid gray",
    borderRight: "1px solid gray",
    borderBottom: "1px solid gray",
  },
  cell4: {
    flex: 1,
    padding: 8,
    fontSize: 12,
    backgroundColor: "#E4E4E4",
    border: "1px solid gray",
  },
  cell5: {
    flex: 1,
    padding: 8,
    fontSize: 10,
  },
  separacion: {
    height: "100px",
  },
  pageBackground: {
    position: "absolute",
    minWidth: "100%",
    minHeight: "100%",
    display: "block",
    height: "100%",
    width: "100%",
  },
  footer: {
    position: "absolute",
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: "left",
    fontSize: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 10,
  },
  pageNumber: {
    fontSize: 10,
  },
});

function ComprobanteTransferencia({ datosImpresion }) {
  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.pageBackground}>
          <Image src={frameAso} />
        </View>
        <Text style={[styles.title, { fontFamily: "Helvetica-Bold" }]}>
          COMPROBANTE DE TRANSFERENCIA ELECTRÓNICA
        </Text>
        <View style={styles.tableHeader}>
          <View style={[styles.row]}>
            <Text
              style={[
                styles.cell1,
              ]}
            >
              DATOS DE LA CUENTA CRÉDITO
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Banco: </Text>
              {datosImpresion.banco}
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell3, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>CBU: </Text>
              {datosImpresion.cbu}
            </Text>
          </View>
          <View style={styles.table}>
            <View style={[styles.row, styles.header]}>
              <Text style={[styles.cell, styles.header]}>
                <Text style={{ fontFamily: "Helvetica-Bold" }}>Fecha: </Text>
                {formatearFechaLuxon(datosImpresion.fechaInterbanking, "dd/MM/yyyy")}
              </Text>
            </View>
          </View>
          ${(datosImpresion.nroTransferencia || datosImpresion.nroTransferencia === '0') &&
            <View style={styles.table}>
              <View style={[styles.row, styles.header]}>
                <Text style={[styles.cell, styles.header]}>
                  <Text style={{ fontFamily: "Helvetica-Bold" }}>Nro. Transferencia: </Text>
                  {datosImpresion.nroTransferencia}
                </Text>
              </View>
            </View>
          }
          ${datosImpresion.nroRed &&
            <View style={styles.table}>
              <View style={[styles.row, styles.header]}>
                <Text style={[styles.cell, styles.header]}>
                  <Text style={{ fontFamily: "Helvetica-Bold" }}>Nro. Red: </Text>
                  {datosImpresion.nroRed}
                </Text>
              </View>
            </View>
          }
          <View style={styles.table}>
            <View style={[styles.row, styles.header]}>
              <Text style={[styles.cell3, styles.header]}>
                <Text style={{ fontFamily: "Helvetica-Bold" }}>Importe: </Text>
                $ {datosImpresion.monto}
              </Text>
            </View>
          </View>
          <View style={styles.tableHeader}>
            <View style={[styles.row]}>
              <Text
                style={[
                  styles.cell1,
                  styles.boldText,
                  { fontFamily: "Helvetica-Bold" },
                ]}
              >
                DATOS DE LA CUENTA DÉBITO
              </Text>
            </View>
          </View>
          <View style={styles.table}>
            <View style={[styles.row, styles.header]}>
              <Text style={[styles.cell, styles.header]}>
                <Text style={{ fontFamily: "Helvetica-Bold" }}>Banco: </Text>
                {datosImpresion.bancoDebito}
              </Text>
            </View>
          </View>
          <View style={styles.table}>
            <View style={[styles.row, styles.header]}>
              <Text style={[styles.cell, styles.header]}>
                <Text style={{ fontFamily: "Helvetica-Bold" }}>Denominación: </Text>
                {"ASOCIART SA ART"}
              </Text>
            </View>
          </View>
          <View style={styles.table}>
            <View style={[styles.row, styles.header]}>
              <Text style={[styles.cell, styles.header]}>
                <Text style={{ fontFamily: "Helvetica-Bold" }}>CUIT: </Text>
                {"30686273330"}
              </Text>
            </View>
          </View>
          <View style={styles.table}>
            <View style={[styles.row, styles.header]}>
              <Text style={[styles.cell3, styles.header]}>
                <Text style={{ fontFamily: "Helvetica-Bold" }}>CBU: </Text>
                {datosImpresion.cbuDebito}
              </Text>
            </View>
          </View>
        </View>
        {datosImpresion.caratulaJuicio &&
          <>
            <View style={styles.tableHeader}>
              <View style={[styles.row]}>
                <Text
                  style={[
                    styles.cell1,
                    styles.boldText,
                    { fontFamily: "Helvetica-Bold" },
                  ]}
                >
                  JUICIO
                </Text>
              </View>
            </View>
            <View style={styles.table}>
              <View style={[styles.row, styles.header]}>
                <Text style={[styles.cell3, styles.header]}>
                  <Text style={{ fontFamily: "Helvetica-Bold" }}>Caratula: </Text>
                  {datosImpresion.caratulaJuicio}
                </Text>
              </View>
            </View>
          </>
        }
      </Page>
    </Document>
  );
}

export default ComprobanteTransferencia